.wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.actions {
  display: flex;
  align-items: center;
  gap: 2px;
}

.replaceButton {
  align-self: flex-start;
}

.actionIconButton {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &.disabled {
    opacity: 0.3;
    pointer-events: none;
  }
}
